export const GoogleButton = () => {
  return (
    <button type="button" className="google-sign-in-button">
      Sign in with Google
    </button>
  );
};
